import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";
import PDFViewerImage74 from "../../../../assets/PDFViewerImages/PDFViewerImage74.jpg";
import PDFViewerImage75 from "../../../../assets/PDFViewerImages/PDFViewerImage75.jpg";
import PDFViewerImage76 from "../../../../assets/PDFViewerImages/PDFViewerImage76.jpg";
import PDFViewerImage77 from "../../../../assets/PDFViewerImages/PDFViewerImage77.jpg";
import PDFViewerImage78 from "../../../../assets/PDFViewerImages/PDFViewerImage78.jpg";
import PDFViewerImage79 from "../../../../assets/PDFViewerImages/PDFViewerImage79.jpg";
import PDFViewerImage80 from "../../../../assets/PDFViewerImages/PDFViewerImage80.jpg";
import PDFViewerImage81 from "../../../../assets/PDFViewerImages/PDFViewerImage81.jpg";
import PDFViewerImage82 from "../../../../assets/PDFViewerImages/PDFViewerImage82.jpg";
import PDFViewerImage83 from "../../../../assets/PDFViewerImages/PDFViewerImage83.jpg";
import PDFViewerImage84 from "../../../../assets/PDFViewerImages/PDFViewerImage84.jpg";
import PDFViewerImage85 from "../../../../assets/PDFViewerImages/PDFViewerImage85.jpg";
import PDFViewerImage86 from "../../../../assets/PDFViewerImages/PDFViewerImage86.jpg";
import PDFViewerImage87 from "../../../../assets/PDFViewerImages/PDFViewerImage87.jpg";
import PDFViewerImage88 from "../../../../assets/PDFViewerImages/PDFViewerImage88.jpg";
import PDFViewerImage89 from "../../../../assets/PDFViewerImages/PDFViewerImage89.jpg";
import PDFViewerImage90 from "../../../../assets/PDFViewerImages/PDFViewerImage90.jpg";
import PDFViewerImage91 from "../../../../assets/PDFViewerImages/PDFViewerImage91.jpg";
import PDFViewerImage92 from "../../../../assets/PDFViewerImages/PDFViewerImage92.jpg";
import PDFViewerImage93 from "../../../../assets/PDFViewerImages/PDFViewerImage93.jpg";
import PDFViewerImage94 from "../../../../assets/PDFViewerImages/PDFViewerImage94.jpg";
import PDFViewerImage95 from "../../../../assets/PDFViewerImages/PDFViewerImage95.jpg";
import PDFViewerImage96 from "../../../../assets/PDFViewerImages/PDFViewerImage96.jpg";
import PDFViewerImage97 from "../../../../assets/PDFViewerImages/PDFViewerImage97.jpg";
import PDFViewerImage98 from "../../../../assets/PDFViewerImages/PDFViewerImage98.jpg";
import PDFViewerImage99 from "../../../../assets/PDFViewerImages/PDFViewerImage99.jpg";
import PDFViewerImage100 from "../../../../assets/PDFViewerImages/PDFViewerImage100.jpg";


const Chapter23 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);


    return (
        <>
                 {/* Chapter 23 */}
                <section id="section23" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">
                       {language.chapter23Title}
                    </h2>

                    <h3 className="drivers-handbook-subheading">{language.chapter23Subheading1}</h3>

                    <div className="image-box">
                        <img src={PDFViewerImage74} alt="Traffic Rules"/>
                    </div>

                    <div className="image-box">
                        <img src={PDFViewerImage75} alt="Traffic Rules"/>
                    </div>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter23Paragraph1}

                    </p>


                    <ul className="drivers-handbook-list">
                        <li>"{language.chapter23List11}
                        </li>

                        <div className="image-box">
                            <img src={PDFViewerImage76} alt="Traffic Rules"/>
                        </div>


                        <li>{language.chapter23List12}</li>


                        <div className="image-box">
                            <img src={PDFViewerImage77} alt="Traffic Rules"/>
                        </div>


                        <li>{language.chapter23List13}</li>

                        <div className="image-box">
                            <img src={PDFViewerImage78} alt="Traffic Rules"/>
                        </div>


                        <li>{language.chapter23List14}</li>

                        <div className="image-box">
                            <img src={PDFViewerImage79} alt="Traffic Rules"/>
                        </div>


                        <li>{language.chapter23List15}
                        </li>

                        <div className="image-box">
                            <img src={PDFViewerImage80} alt="Traffic Rules"/>
                        </div>


                        <div className="image-box">
                            <img src={PDFViewerImage81} alt="Traffic Rules"/>
                        </div>
                        <div className="image-box">
                            <img src={PDFViewerImage82} alt="Traffic Rules"/>
                        </div>


                        <li>{language.chapter23List16}
                        </li>

                        <div className="image-box">
                            <img src={PDFViewerImage83} alt="Traffic Rules"/>
                        </div>


                        <li>{language.chapter23List17}
                        </li>

                        <div className="image-box">
                            <img src={PDFViewerImage84} alt="Traffic Rules"/>
                        </div>


                        <li>{language.chapter23List18}
                        </li>

                        <div className="image-box">
                            <img src={PDFViewerImage85} alt="Traffic Rules"/>
                        </div>


                        <li>{language.chapter23List19}
                        </li>

                        <div className="image-box">
                            <img src={PDFViewerImage86} alt="Traffic Rules"/>
                        </div>

                        <li>{language.chapter23List20}</li>


                        <div className="image-box">
                            <img src={PDFViewerImage87} alt="Traffic Rules"/>
                        </div>


                        <li>{language.chapter23List21b}</li>

                        <div className="image-box">
                            <img src={PDFViewerImage88} alt="Traffic Rules"/>
                        </div>


                        <li>{language.chapter23List22b}</li>

                        <div className="image-box">
                            <img src={PDFViewerImage89} alt="Traffic Rules"/>
                        </div>


                        <li>{language.chapter23List23b}</li>

                        <div className="image-box">
                            <img src={PDFViewerImage90} alt="Traffic Rules"/>
                        </div>


                        <li>{language.chapter23List24b}</li>

                        <div className="image-box">
                            <img src={PDFViewerImage91} alt="Traffic Rules"/>
                        </div>


                        <li>{language.chapter23List25}</li>

                        <div className="image-box">
                            <img src={PDFViewerImage92} alt="Traffic Rules"/>
                        </div>


                        <li>{language.chapter23List26}</li>

                        <div className="image-box">
                            <img src={PDFViewerImage93} alt="Traffic Rules"/>
                        </div>


                        <li>{language.chapter23List27}</li>

                        <div className="image-box">
                            <img src={PDFViewerImage94} alt="Traffic Rules"/>
                        </div>


                        <li>{language.chapter23List28}</li>

                        <div className="image-box">
                            <img src={PDFViewerImage95} alt="Traffic Rules"/>
                        </div>


                        <li>{language.chapter23List29}</li>
                        <div className="image-box">
                            <img src={PDFViewerImage96} alt="Traffic Rules"/>
                        </div>

                    </ul>

                    <h3 className="drivers-handbook-subheading">{language.chapter23Subheading2}</h3>

                    <div className="image-box">
                        <img src={PDFViewerImage97} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter23Paragraph2}
                    </p>
                    <ul className="drivers-handbook-list">
                        <li>{language.chapter23List21}</li>
                        <li>
                            {language.chapter23List22}
                        </li>
                        <li>{language.chapter23List23}</li>
                        <li>{language.chapter23List24}</li>
                    </ul>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter23List31}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage98} alt="Traffic Rules"/>
                    </div>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter23List32}

                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage99} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                       {language.chapter23List32}


                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage100} alt="Traffic Rules"/>
                    </div>


                    <ul className="drivers-handbook-list">
                        <li>{language.chapter23List41}</li>
                    <li>{language.chapter23List42}</li>
                     <li>{language.chapter23List43}</li>
                     <li>{language.chapter23List44}</li>
                     <li>{language.chapter23List45}</li>
                     <li>{language.chapter23List46}</li>
                     <li>{language.chapter23List47}</li>
                    <li>{language.chapter23List48}</li>
                    <li>{language.chapter23List49}</li>
                    <li>{language.chapter23List50}</li>
                     <li>{language.chapter23List51}</li>
                    <li>{language.chapter23List52}</li>
                    <li>{language.chapter23List53}</li>
                    <li>{language.chapter23List54}</li>
                    <li>{language.chapter23List55}</li>
                    <li>{language.chapter23List56}</li>
                    <li>{language.chapter23List57}</li> 
                    <li>{language.chapter23List58}</li>
                    <li>{language.chapter23List59}</li>
                    <li>{language.chapter23List60}</li>
                    <li>{language.chapter23List61}</li>
                    <li>{language.chapter23List62}</li>
                    <li>{language.chapter23List63}</li>
                    <li>{language.chapter23List64}</li>
                    <li>{language.chapter23List65}</li>
                    <li>{language.chapter23List66}</li>
                    <li>{language.chapter23List67}</li>
                    <li>{language.chapter23List68}</li>
                    <li>{language.chapter23List69}</li>
                    <li>{language.chapter23List70}</li>                       


                    </ul>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter23Paragraph3}

                    </p>


                </section>

        </>
    )

}

export default Chapter23;
